import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Environment, MagazziniMoviTipo, MagazziniMoviTipoLng } from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class MagazziniMoviTipoService extends CrudGenericsService<MagazziniMoviTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniMoviTipo`);
    this.base = `${env.apiUrl}/api/MagazziniMoviTipo/`;
  }

  GetAllLng_ByCaricoScarico(carico_true_scarico_false: boolean): Observable<MagazziniMoviTipoLng[]> {
    const url = this.base + 'GetAllLng_ByCaricoScarico?carico_true_scarico_false=' + carico_true_scarico_false;
    return this.http.get<MagazziniMoviTipoLng[]>(`${url}`);
  }

  GetAllLng(): Observable<MagazziniMoviTipoLng[]> {
    const url = this.base + 'GetAllLng';
    return this.http.get<MagazziniMoviTipoLng[]>(`${url}`);
  }
}
